module.exports = __webpack_public_path__ + "assets/media/1.f17ec6b6.wav";